<template>
  <div
    class="label-input-field-container"
    :class="{'disabledLabel': disabled}"
  >
    <!-- 所有标签 -->
    <div>
      <span
        v-if="showUrgentLabel"
        class="select-color label-input-field"
        contenteditable="false"
        @click="handelUrgent"
      >#加急派送</span>
      <span
        v-for="item in list"
        :key="item.id"
        class="select-color label-input-field"
        contenteditable="false"
        :id="item.id"
        @click="insertLabel($event, item.fastWord)"
      >{{ item.scene }}</span>
    </div>
    <div class="el-textarea el-input--small el-input--suffix">
      <div
        ref="editableDiv"
        class="el-textarea__inner label-textarea"
        :class="[{ 'is-error-textarea': this.isError }, `textarea-${random}`]"
        contenteditable="true"
        :placeholder="$lang('请输入')"
        @blur="textareaBlur"
        @input="textareaBlur"
        @keypress="onKeypress"
        @compositionend="onCompositionend"
        @focus="textareaFocus"
      >
      </div>
      <div>
        <span class="el-input__count">
          <span class="el-input__count-inner">
            {{ labelCount }}
            <span class="el-input__count-separator">/</span>
            <span class="el-input__count-inner">{{ maxlength }}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LabelInputField',
  props: {
    isRequired: {
      type: Boolean,
      default: false
    },
    // 总数
    maxlength: {
      type: Number,
      default: 500
    },
    // 标签列表
    list: {
      type: Array,
      default: () => []
    },
    // 是否支持重复选择
    isRepeat: {
      type: Boolean,
      default: false
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    showUrgentLabel: {
      type: Boolean,
      default: false
    },
    urgentOrderFlag: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      isError: false,
      // 总数
      labelCount: 0,
      // 随机数
      random: Math.floor(Math.random() * 10000),
      // 当前添加的标签
      currentLabel: '',
      // 选中标签文本
      currentLabelText: '',
      // 光标位置
      cursorPosition: 0,
      // 快速标签
      fastWordLabel: ''
    };
  },
  mounted() {
    this.isMultiple = this.list[0] && this.list[0].multipleChoice === 1;
    if (this.isMultiple) {
      this.currentLabel = []
    }
  },
  methods: {
    handelUrgent(e) {
      this.$emit('update:urgent', this.urgentOrderFlag === 1 ? 2 : 1)
      this.$nextTick(() => {
        this.changeUrgent(e)
      })
    },
    /**
     * 插入加急
     */
    changeUrgent(e) {
      const labelTextarea = document.querySelector(`.textarea-${this.random}`)
      const firstChild = labelTextarea.firstElementChild
      if (this.urgentOrderFlag === 1 && e && !(firstChild && firstChild.classList.contains('urgent-label'))) {
        const urgentLabel = e.target.cloneNode(true)
        urgentLabel.classList.add('urgent-label')
        labelTextarea.prepend(urgentLabel)
      } else if (firstChild && firstChild.classList.contains('urgent-label')) {
        firstChild.remove()
      }
      this.onInput(labelTextarea)
    },
    textareaBlur(e) {
      this.onCompositionend(e);
      this.onInput(e.target);
      if (this.isRequired && !e.target.innerText) {
        this.isError = true;
      }
    },
    // 插入标签
    insertLabel(e, fastWord = '') {
      const labelTextarea = document.querySelector(`.textarea-${this.random}`);
      const length = e.target.innerText.length;
      const id = e.target.id;
      const isFind = labelTextarea.innerHTML.indexOf(id) > -1;
      if (
        length + labelTextarea.innerText.length + fastWord.length > this.maxlength ||
        (isFind && !this.isRepeat)
      ) {
        return;
      }
      // 克隆e节点全部属性
      const labelNode = e.target.cloneNode(true);
      // 插入父节点 如果是单选且已选择则删掉替换新节点
      if (
        !this.isMultiple
      ) {
        if (labelTextarea.innerText.indexOf(this.currentLabel.innerText) === -1) {
          this.currentLabel = ''
        }
        this.currentLabel && labelTextarea.removeChild(this.currentLabel);
        this.currentLabel = labelNode;
        this.fastWordLabel && this.fastWordLabel === labelTextarea.lastChild?.innerText && labelTextarea.removeChild(labelTextarea.lastChild)
      }
      if (this.isMultiple) {
        this.currentLabel.push(labelNode);
        this.currentLabel = [...new Set(this.currentLabel)]
      }
      const firstChild = labelTextarea.firstChild;
      if (firstChild && firstChild.classList && firstChild.classList.contains('urgent-label')) {
        if (firstChild.nextSibling) {
          labelTextarea.insertBefore(labelNode, firstChild.nextSibling);
        } else {
          labelTextarea.appendChild(labelNode);
        }
      } else if (firstChild) {
        labelTextarea.insertBefore(labelNode, firstChild);
      } else {
        labelTextarea.appendChild(labelNode); // 如果没有子节点，则添加到末尾
      }
      if (fastWord && fastWord?.length) {
        labelTextarea.appendChild(document.createTextNode(fastWord))
        this.fastWordLabel = fastWord
      }
      this.onInput(labelTextarea)
    },
    onKeypress(event) {
      // 阻止表单提交
      if (event.target.innerText.length >= this.maxlength) {
        event.preventDefault();
      }
    },
    onCompositionend(event) {
      const diff = event.target.innerText.length - this.maxlength;
      if (diff > 0) {
        const range = document.createRange();
        // 获取选中的文本
        const sel = window.getSelection();
        // 获取选中的起始位置
        const offset = sel.anchorOffset;
        // 获取选中的节点
        const node = sel.anchorNode;
        // 获取选中的文本内容
        const text = node.textContent;
        // 选择节点内的所有内容
        range.selectNodeContents(node);
        // 移除所有选区
        sel.removeAllRanges();
        // 设置定时器，等待执行命令
        setTimeout(() => {
          // 添加选区
          sel.addRange(range);
          // 扩展选区
          sel.extend(node, offset);
          // 删除选中的文本
          document.execCommand('delete', false);
          // 将文本插入到当前位置
          document.execCommand('insertText', false, text.substring(0, offset - diff));
        }, 0);
      }
    },
    // 传给父组件内容
    onInput(target) {
      // 更新标签计数
      this.labelCount = target.innerText.length;
      // 触发自定义事件，传递标签的HTML内容
      let pureText = ''
      if (target && target.childNodes) {
        pureText = Array.from(target.childNodes)
          .filter(node => {
            return node.nodeType === Node.TEXT_NODE || !(node.classList && node.classList.contains && node.classList.contains('label-input-field'))
          }) // 只保留非标签节点
          .map(node => node.innerText || node.nodeValue || '') // 提取文本
          .join('');
      }
      this.$emit('innerText', pureText);
      this.$emit('innerHTML', target.innerHTML);
      let list = []
      let textList = []
      // 判断是否为多选模式
      if (this.isMultiple) {
        // 在当前标签数组中过滤与target的innerHTML相匹配的标签，并映射为outerHTML
        list = this.currentLabel?.filter(item => target.innerHTML.indexOf(item.innerHTML) > -1).map(item => item.outerHTML) || []
        textList = this.currentLabel?.filter(item => target.innerHTML.indexOf(item.innerHTML) > -1).map(item => item.innerText) || []
      } else {
        // 如果找到匹配的标签，则将当前标签的outerHTML放入list中，否则list为空数组
        list = this.currentLabel && target.contains(this.currentLabel) ? [this.currentLabel.outerHTML] : []
        textList = this.currentLabel && target.contains(this.currentLabel) ? [this.currentLabel.innerText] : []
      }
      if (!target.querySelector('.urgent-label') && this.urgentOrderFlag === 1) {
        this.$emit('update:urgent', 2)
      }
      // 触发自定义事件，传递标签的outerHTML列表
      this.$emit('labelCount', list);
      // 触发自定义事件，传递标签文本
      this.$emit('labelTextList', textList);
      // 更新当前标签的文本内容
      this.currentLabelText = document.querySelector(`.textarea-${this.random}`).innerText
    },
    /**
     * 清空
     */
    reset() {
      this.labelCount = 0;
      this.currentLabel = ''
      const labelTextarea = document.querySelector(`.textarea-${this.random}`);
      labelTextarea.innerHTML = '';
    },
    /**
     * 写入数据
     */
    write(data) {
      const labelTextarea = document.querySelector(`.textarea-${this.random}`);
      labelTextarea.innerHTML = data || '';
      this.labelCount = labelTextarea.innerHTML.length
    },
    textareaFocus() {
      this.$emit('textareaFocus', new Date().getTime())
    }
  }
};
</script>

<style lang="scss" scoped>
.label-input-field-container {
  width: 100%;
  .label-input-field {
    color: #5f5fff;
    padding-right: 5px;
    display: inline-block;
  }

  .label-textarea {
    min-height: 80px;
    padding: 4px;
  }

  .label-textarea:hover,
  .is-error-textarea {
    border-color: #e60012;
  }
  .label-textarea:empty:before {
    content: attr(placeholder);
    color: #999999;
  }

  .label-textarea:focus:before {
    content: none;
  }
  .select-color {
    /* margin: 0 4px; */
    cursor: pointer;
  }
}
.disabledLabel {
  pointer-events: none;
}
</style>
